import { useFeatureFlags } from '../hooks/useFeatureFlags';

/**
 * Kick off the feature flags fetch at app startup — before any feature
 * component mounts and checks flags. Renders nothing; RTK Query deduplicates
 * the request so all consumers share the same cache entry.
 */
export function FeatureFlagsPrefetch(): null {
  useFeatureFlags();
  return null;
}
